import React from 'react';
import Salary_Increment from './Salary_Increment';
import '../../../CommonCSS/SocietyCSS.css'

const Salary_IncrementApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Salary Increment</h5>
          </div>  
        </div>
        <Salary_Increment/>
      </div>
    </div >
  );
};

export default Salary_IncrementApp;
